import { makeStyles } from '@mui/styles';
import Card from 'apollo-react/components/Card';
import Typography from 'apollo-react/components/Typography';
import React from 'react';
import { useSelector } from 'react-redux';

import { useTranslation } from '../../custom-hooks/useTranslation';
import { getImportRecordProp } from '../../selectors/PowerBISelectors';

const useStyles = makeStyles({
  infoContainer: {
    margin: '15px 0px',
    padding: 10,
  },
  errorMessage: {
    color: 'red',
  },
  successMessage: {
    color: '#00c221',
  },
});

const ImportInfo = () => {
  const translateString = useTranslation();
  const classes = useStyles();

  const hasImportError = useSelector(getImportRecordProp('hasImportError'));
  const errorMessage = useSelector(getImportRecordProp('errorMessage'));

  return (
    <Card color="dark" className={classes.infoContainer}>
      {hasImportError ? (
        <Typography className={classes.errorMessage}>{translateString(errorMessage)}</Typography>
      ) : (
        <Typography className={classes.successMessage}>
          {translateString('Import has been successfully completed')}
        </Typography>
      )}
    </Card>
  );
};

export default ImportInfo;
